import React from 'react';
import { useTheme } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';

export const SimIconButtonThemed = ({ size = 'small', Icon, sx = {} }) => {
	const theme = useTheme();

	return (
		<IconButton size={size} sx={{ color: theme.palette.background.default, ...sx }}>
			{Icon && <Icon />}
		</IconButton>
	);
};
